import React from 'react';
import { useSelector } from 'react-redux';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';
import { RootState } from '@/setup/redux/RootReducer';

const GlobalLoadingBackdrop: React.FC = () => {
  const { isLoading, message } = useSelector((state: RootState) => state.globalLoading);

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
      open={isLoading}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress color="inherit" size={60} />
        <Typography
          variant="h6"
          sx={{
            color: 'white',
            fontWeight: 500,
            textAlign: 'center',
            maxWidth: 300,
          }}
        >
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default GlobalLoadingBackdrop;
